import { useMutation, UseMutationOptions, useQuery, UseQueryOptions } from "@tanstack/react-query";
import $api from "../../../api/$api";
import { ICreateOrgSuperAdminData, IUpdateOrg, TDataToken, TQueries } from "./type";
//get org all
export const getOrgList = (data: TDataToken, payload: TQueries) => {
  return $api
    .get(`/admin/orgs`, { token: data.accessToken, params: { ...payload } })
    .then((response) => {
      return response;
    });
};

export const useOrgListSA = (
  data: TDataToken,
  queries: TQueries,
  config?: {}
) => {
  return useQuery({
    queryKey: ["orgListSA", queries],
    queryFn: () => getOrgList(data, queries) as any,
    ...(config as UseQueryOptions<unknown>),
  });
};

//get all users
export const getUserList = (data: TDataToken, payload: TQueries) => {
  return $api
    .get(`/admin/users`,{ token: data.accessToken, params: { ...payload }})
    .then((response) => {
      return response;
    });
};

export const useUserListSA = (
  data: TDataToken,
  queries: TQueries,
  config?: {}
) => {
  return useQuery({
    queryKey: ["userListSA", queries],
    queryFn: () => getUserList(data, queries) as any,
    ...(config as UseQueryOptions<unknown>),
  });
};


//get single user details
export const getUserDetails = (data: TDataToken, payload: TQueries) => {
  return $api
    .get(`/admin/users/${payload?.userID}/organizations`,{ token: data.accessToken})
    .then((response) => {
      return response;
    });
};

export const useUserDetailsSA = (
  data: TDataToken,
  queries: TQueries,
  config?: {}
) => {
  return useQuery({
    queryKey: ["userDetailsSA", queries],
    queryFn: () => getUserDetails(data, queries) as any,
    ...(config as UseQueryOptions<unknown>),
  });
};

// get users of an organiztion
export const getOrgUsers = (data: TDataToken, payload: TQueries) => {
  return $api
    .get(`/admin/orgs/users`,{ token: data.accessToken, params: { ...payload }})
    .then((response) => {
      return response;
    });
};

export const useOrgUsers = (
  data: TDataToken,
  queries: TQueries,
  config?: {}
) => {
  return useQuery({
    queryKey: ["orgUserList", queries],
    queryFn: () => getOrgUsers(data, queries) as any,
    ...(config as UseQueryOptions<any>),
  });
};


// get single org details
export const getOrgDetails = (data: TDataToken, payload: TQueries) => {
  return $api
    .get(
      `/admin/orgs/details`,
     { token: data.accessToken, params: { ...payload }}
    )
    .then((response) => {
      return response
    });
};
export const useOrgDetailsSA = (
  data: TDataToken,
  queries: TQueries,
  config?: {}
) => {
  return useQuery({
    queryKey: ["orgUserDetails", queries],
    queryFn: () => getOrgDetails(data, queries) as any,
    ...(config as UseQueryOptions<any>),
  });
};

export const createOrg = (
  data: TDataToken,
  payload: ICreateOrgSuperAdminData
) => {
  return $api
    .post("/admin/orgs/create", { ...payload }, { token: data.accessToken })
    .then((response) => {
      return response;
    });
};

export const useCreateOrg = (
  data: TDataToken,
  config?: UseMutationOptions<any, unknown, ICreateOrgSuperAdminData>
) => {
  return useMutation({
    mutationFn: (payload:ICreateOrgSuperAdminData) =>
      createOrg(data, payload),
    ...config
  });
};


export const updateOrg = (data: TDataToken, payload: IUpdateOrg, queries: TQueries) => {
  return $api
    .put(
      `/admin/orgs/${queries.orgID}/update`,
      { ...payload },
      { token: data.accessToken, params: { ...queries } }
    )
    .then((response) => {
      return response;
    });
};

export const useUpdateOrg = (
  data: TDataToken,
  queries: TQueries,
  config?: UseMutationOptions<any, unknown, IUpdateOrg>
) => {
  return useMutation({
    mutationFn: (payload:IUpdateOrg) =>
      updateOrg(data, payload,queries),
    ...config
  });
};
